import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";

const EditQualityRuleAssociation = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location);

    // select dropdown
    const [item, setItem] = useState([]);
    const [rule, setRule] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    const { useUpdate } = useAPIQuery({
        key: "quality-rule-assoc",
        endpoint: "/api/quality-rule-association/",
    });

    const handleUpdateQualityRuleAssoc = (data) => {
        Swal.fire({
            title: "Quality Rule Association Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorQualityRuleAssoc = (data) => {
        Swal.fire({
            title: "Error Updating Quality Rule Association",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdateQualityRuleAssoc,
        onError: handleErrorQualityRuleAssoc,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var quality_rule_asso = {
            item_id: data.item_id.value,
            rule_id: data.rule_id.value,
            updated_by: userID,
        };

        mutate({
            id: location.state.editpost.id,
            data: quality_rule_asso,
        });
    };

    // Pre Population of Particular Product details
    useEffect(() => {
        const editQualityRuleAssoc = location.state.editpost;
        // defaultValues is a react form hook.
        if (editQualityRuleAssoc) {
            var defaultValues = {};

            const getItem = {
                value: editQualityRuleAssoc.item?.id,
                label: editQualityRuleAssoc.item?.item_name,
            };
            defaultValues.item_id = getItem;

            const getQualityParameter = {
                value: editQualityRuleAssoc.parameter?.id,
                label: editQualityRuleAssoc.parameter?.parameter_name,
            };
            defaultValues.parameter_id = getQualityParameter;

            reset(defaultValues);
        }
    }, []);

    useEffect(() => {
        if (data) {
            setItem(data.item);
            setRule(data.quality_rule);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            Edit Quality Parameter Rule Association
                        </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label: api?.item_name,
                                                    };
                                                })}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Quality Rule{" "}
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={rule?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label: api?.parameter_name,
                                                    };
                                                })}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-rule"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="rule_id"
                                        control={control}
                                    />
                                    {errors.rule_id && (
                                        <span className="fs-8 text-danger">
                                            Quality Rule is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-quality-parameter-rule-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-quality-parameter-rule"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditQualityRuleAssociation;
